import styled from '@emotion/styled';

import ArrowDownIcon from '@/assets/svg/ui-elements/arrow-down.svg';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
}));

const Rule = styled('span')(({ theme }) => ({
  flex: 1,
  height: 1,
  backgroundColor: theme.colors.border.default,
}));

const Badge = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 24,
  height: 24,
  borderRadius: theme.radius.full,
  backgroundColor: theme.colors.info.solid,
  color: theme.colors.info.onInfo,

  '& svg': {
    width: 14,
    height: 14,
  },
}));

export const SendDivider = () => (
  <Root aria-hidden>
    <Rule />
    <Badge>
      <ArrowDownIcon />
    </Badge>
    <Rule />
  </Root>
);
